<template>
  <div class="notification-icon">
    <div class="value">{{value}}</div>
  </div>
</template>

<script>
  export default {
    name: 'NotificationIcon',
    props: ['value']
  }
</script>

<style scoped>
  .notification-icon {
    display: flex;
    position: absolute;
    top: -8px;
    right: -20px;
  }
  .notification-icon .value {
    background-color: #fa3e3e;
    border-radius: 2px;
    color: #fff;
    padding: 1px 3px;
    font-size: 10px;
    line-height: 15px;
    height: 15px;
  }
</style>
